(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laik-showrooms"] && !Shopify.designMode) return;
  try {
    

    let swiper = null;

    function initSwiper() {
        console.log("Swiper init");
        swiper = new Swiper(".swiper-general", {
            // Optional parameters
            direction: "horizontal",
            loop: true,
            autoplay: {
              delay: 3000,
            },

            // If we need pagination
            pagination: {
              el: ".swiper-pagination",
            },

            // Navigation arrows
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
    }

    document.addEventListener("DOMContentLoaded", function (event) {
        console.log("DOMContentLoaded");
        initSwiper();
    });

    document.addEventListener("shopify:section:load", function (event) {
        console.log("shopify:section:load");
    });

    document.addEventListener("shopify:section:unload", function (event) {
        console.log("shopify:section:unload");
    });

    document.addEventListener("shopify:section:select", function (event) {
        console.log("shopify:section:select")
    });

    document.addEventListener("shopify:section:deselect", function (event) {
        console.log("shopify:section:deselect")
    });


  } catch(e) { console.error(e); }
})();
})();
